import React from 'react';
import omit from 'lodash/omit';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';

import Modal from './Modal.jsx';

const ModalAlert = (props) => {
  const { icon, children, onHide } = props;

  return (
    <Modal
      size="sm"
      centered
      className="text-center p-4"
      {...omit(props, ['children', 'icon'])}
    >
      {icon !== null && (
        <div className="display-2 my-3 text-danger">
          <FA icon={icon || faTimesCircle} />
        </div>
      )}
      {children}
      <div className="mt-3">
        <button
          className="btn btn-danger btn-block"
          onClick={onHide}
        >
          OK
        </button>
      </div>
    </Modal>
  );
};

export default ModalAlert;
